import { ScreenView } from '../../constants/global.constant';
import { KngCardListState, SortOrder } from './definitions';

export class KngCardListFactory 
{
	public static build(): KngCardListState 
	{
		return {
			view: ScreenView.tableDesktop,
			header: [
				{
					label: ' ',
					isSort: true,
					sortOrder: SortOrder.asc
				},
				{
					label: ' ',
					isSort: true,
					sortOrder: SortOrder.asc
				}
			],
			cardListAccordionIcon: {
				url: '',
				alt: ''
			},
			cardListGrayIcon: {
				url: '',
				alt: ''
			},
			cardListOrangeIcon: {
				url: '',
				alt: ''
			},
			pageInfo: {
				pageSize: 0,
				totalCount: 0
			},
			tooltipMessage: '',
			serviceCampaignAltText: '',
			moreIconAltText: '',
			list: [
				{
					collapsed: false,
					values: [],
					id: '',
					changeRequest: {
						display: '',
						tooltip: '',
						toastMessage: '',
						bannerMessage: ''
					}
				}
			],
			loading: true,
			activeFlag: ''
		};
	}
}
